// Stroke icons share one 24px grid so they line up with text at any size.
const Icon = ({ size = 20, children, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    {children}
  </svg>
);

export const PinIcon = (p) => (
  <Icon {...p}>
    <path d="M12 21s-6.5-5.6-6.5-10.5a6.5 6.5 0 1 1 13 0C18.5 15.4 12 21 12 21z" />
    <circle cx="12" cy="10.5" r="2.3" />
  </Icon>
);

export const PhoneIcon = (p) => (
  <Icon {...p}>
    <path d="M5.2 3.5h3l2 5-2.4 1.6a11.5 11.5 0 0 0 6.1 6.1l1.6-2.4 5 2v3a2 2 0 0 1-2.1 2A16.5 16.5 0 0 1 3.2 5.6a2 2 0 0 1 2-2.1z" />
  </Icon>
);

export const ShieldIcon = (p) => (
  <Icon {...p}>
    <path d="M12 3l7 3v5.2c0 4.4-3 8.3-7 9.8-4-1.5-7-5.4-7-9.8V6z" />
    <path d="M9 12.2l2.1 2.1L15.2 10" />
  </Icon>
);

export const MailIcon = (p) => (
  <Icon {...p}>
    <rect x="3" y="5" width="18" height="14" rx="2.5" />
    <path d="M3.5 7.5l8.5 6 8.5-6" />
  </Icon>
);

export const ArrowIcon = (p) => (
  <Icon {...p}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </Icon>
);

export const CheckIcon = (p) => (
  <Icon {...p}>
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </Icon>
);

export const ChevronIcon = (p) => (
  <Icon {...p}>
    <path d="M6 9l6 6 6-6" />
  </Icon>
);

export const CloseIcon = (p) => (
  <Icon {...p}>
    <path d="M6 6l12 12M18 6L6 18" />
  </Icon>
);

export const GrowthIcon = (p) => (
  <Icon {...p}>
    <path d="M4 19.5h16" />
    <path d="M5.5 15l4-4 3 3 6-6.5" />
    <path d="M14.5 7.5h4v4" />
  </Icon>
);

export const BagIcon = (p) => (
  <Icon {...p}>
    <path d="M4.5 8h15l-1.1 11.1a2 2 0 0 1-2 1.9H7.6a2 2 0 0 1-2-1.9z" />
    <path d="M8.8 8V6.6a3.2 3.2 0 0 1 6.4 0V8" />
  </Icon>
);

export const ScooterIcon = (p) => (
  <Icon {...p}>
    <circle cx="6" cy="17" r="2.6" />
    <circle cx="18" cy="17" r="2.6" />
    <path d="M8.6 17h6.8l-2-7h-3M13.4 10l1.4-3.5H17M18 14.4 16.5 10H20" />
  </Icon>
);
